/** @module csi/view/SelectController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller"
], function(declare,_,Controller) {

	return declare(Controller, {
		/**
		 * Select or deselect node(s) in view.
		 */
		postProcessSuccess: function() {
			// if just selecting table row for sake of visibility, then nothing more to do
			var view = this.widget;
			if (!view.allowsSelections()) {
				return;
			}

			this.setProgress();

			var fd = view.defView.m_formData;
			var refNode = view.getRefNode(this.m_element);
			var url = refNode && view.getRefNodeUrl(refNode);
			if (url) {
				// toggle single selection and ensure selection is in view
				var ctx = view.getContext(url);
				var bSelect = fd.m_bSelectOne || !fd.isSelection(ctx);

				view.toggleRefNodeSelection(refNode, bSelect);
				
				// if select was not caused by mouse click, then scroll node into view
				if (!this.bClick) {
					this.widget.scrollIntoView(refNode);
				}
			} else if (!fd.m_bRequireOne) {
				// only reset all selections if not required to pick just one
				fd.resetSelections(view.getContext());
			}
		}
	});
});
